import { Input, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { translateModel } from '../../../../../utils/translate';
import { FIELD } from '../constants/field';
import FormField from './FormField';

const CustomFieldInput = ({
  field_id,
  hint_translations,
  name_translations,
  required,
}) => {
  const { errors, register, formState, trigger } = useFormContext();
  const { t, i18n } = useTranslation();
  const hasError = Boolean(errors[FIELD.CUSTOM_DATA]?.[field_id]);
  const name = translateModel(name_translations, i18n.language);
  const placeholder = translateModel(hint_translations, i18n.language);
  const label = `${name} ${
    required ? '' : t('membership.profile.optional_field')
  }`;
  const handleChange = useCallback(() => {
    if (formState.isSubmitted) {
      trigger(`${FIELD.CUSTOM_DATA}.${field_id}`);
    }
  }, [field_id, formState.isSubmitted, trigger]);

  return (
    <FormField label={label} hasError={hasError}>
      <Input
        ref={register}
        name={`${FIELD.CUSTOM_DATA}.${field_id}`}
        onChange={handleChange}
        data-e2e-id={`member-center-profile-custom-field_field--${field_id}`}
        placeholder={placeholder}
      />
      {hasError && (
        <Text variant="errorMessage" textAlign="right">
          {t(errors[FIELD.CUSTOM_DATA][field_id].message, {
            field_name: name,
          })}
        </Text>
      )}
    </FormField>
  );
};

CustomFieldInput.propTypes = {
  field_id: PropTypes.string.isRequired,
  name_translations: PropTypes.objectOf(PropTypes.string),
  hint_translations: PropTypes.objectOf(PropTypes.string),
  required: PropTypes.bool,
};

export default CustomFieldInput;
